const handleHeaderSearchMobile = () => {
	const $searchTrigger = $('.js-header-search-trigger');
	const $search = $('.js-header-search');

	$searchTrigger.on('click', function(event) {
		event.preventDefault();

		$search.slideToggle();
		$('.js-nav-trigger').removeClass('nav-trigger--active');
		$('.js-nav-container').removeClass('is-active');
	});
};

handleHeaderSearchMobile();
